import React from "react";
import { modalBGColor } from "utils/customStyles";

const ErrorMessage = ({ message }) => {
  return (
    <div style={modalBGColor} className="py-8 px-12 max-w-screen-md">
      <p className="text-2xl">Error:</p>
      <div className="text-2xl text-red-600">{message}</div>
    </div>
  );
};

export default ErrorMessage;